import { CHAT_TYPE } from "./../../types/navigation-mode";
import { useState, useEffect } from "react";
import Text from "../text/text";
import NavForm from "../nav-form";
import { useAppStore } from "./../../store/appStore";
import ImageButton from "../button/image-button";
import { HomeVoice } from "./home-voice";
import { useNavigate } from "react-router";
import { tabList } from "@/const/homeConst";
import { useExplorationStore } from "@/store/explorationStore";
import AgentChatDropdown from "../controls/agent-chat-dropdown";

interface HomeChatProps {
  onSend?: Function;
  withTabs?: boolean;
  chatType?: string;
}

export default function HomeChat({
  onSend,
  withTabs = true,
  chatType = CHAT_TYPE.NAVIGATION,
}: HomeChatProps) {
  const isVoiceChatMode = useAppStore((state) => state.isVoiceChatMode);
  const setVoiceChatMode = useAppStore((state) => state.setVoiceChatMode);
  const setPrevChatType = useExplorationStore(
    (state) => state.setPrevChatType
  );

  let navigate = useNavigate();
  // const tabList = [
  //   {
  //     name: "chat_tab_navigate",
  //     placeholder: "chat_nav_placeholder",
  //     type: CHAT_TYPE.NAVIGATION,
  //   },
  //   {
  //     name: "chat_tab_simulation",
  //     placeholder: "chat_sim_placeholder",
  //     type: CHAT_TYPE.SIMULATION,
  //   },
  //   {
  //     name: "chat_tab_exploration",
  //     placeholder: "chat_nav_placeholder",
  //     type: CHAT_TYPE.EXPLORATION,
  //   },
  // ];

  const [selectedTab, setSelectedTab] = useState(
    () => tabList.find((c) => c.type === chatType) || tabList[0]
  );
  const setChatType = useAppStore((state) => state.setChatType);

  useEffect(() => {
    const tab = tabList.find((c) => c.type === chatType);
    if (tab) {
      setSelectedTab(tab);
      setChatType(tab.type);
    }
  }, [chatType]);

  const onSelect = (tab: any) => {
    setPrevChatType(chatType)
    if (tab.type === CHAT_TYPE.EXPLORATION) {
      // setShowExplorationPanel(true);
      navigate("/explore/map")
    } else {
      setSelectedTab(tab);
    }
    setChatType(tab.type);
  };

  const tabs = () => {
    return (
      <div className="flex tabs justify-between mb-[16px]">
        {tabList.map((tab) => {
          return (
            <div
              key={`tab-${tab.type}`}
              className="flex grow justify-center"
              onClick={() => {
                onSelect(tab);
              }}
            >
              <Text
                text={tab.name}
                className={`text-center w-full py-[8px] ${selectedTab.type === tab.type
                  ? `selected-tab`
                  : "disabled-text"
                  }`}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const inputMode = () => {
    return (
      <>
        <NavForm
          fromChat={true}
          placeholder={selectedTab.placeholder}
          onSubmit={() => (onSend ? onSend() : null)}
          inputWithBorder={false}
          redirectToNav={true}
          chatType={selectedTab.type}
        />
        <div className="flex items-center justify-between btn-voice-mobile-chat">
          <ImageButton
            onClick={() => {
              setVoiceChatMode(true);
            }}
            src="/assets/icon_mic_on.png"
            alt="microphone icon"
            className="block mx-auto mt-[16px]"
            size={38}
          />
          <div className="block mx-auto mt-[16px] ml-[8px]">
            <AgentChatDropdown />
          </div>
        </div>
      </>
    );
  };

  const voiceMode = () => {
    return (
      <>
        <HomeVoice
          bottomPanel={true}
          onClose={() => {
            setVoiceChatMode(false);
          }}
          redirectToNav={true}
        />
      </>
    );
  };

  return (
    <div className="sticky bottom-5 w-[calc(100%-40px)] md:max-w-[520px] rounded-xl mx-auto">
      <div className="relative">
        <div className="gradient-border-outer">
          <div
            className={`gradient-border bg-chatpanel rounded-lg md:h-full flex px-[20px] py-[16px] grid`}
          >
            {withTabs ? tabs() : null}
            {isVoiceChatMode ? voiceMode() : inputMode()}
          </div>
        </div>
      </div>
    </div>
  );
}
